import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: "",
  type: "", // Success, Error, Info, etc.
  isVisible: false,
  //   showToastBtn: false,
  //   buttonFunction: null,
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action) => {
        console.log('action.payload',action.payload)
      state.message = action.payload.message;
      state.type = action.payload.type;
      //   if (action.payload.showToastBtn) {
      //     state.showToastBtn = action.payload.showToastBtn;
      //     state.buttonText = action.payload.buttonText;
      //   }
      state.isVisible = true;
    //   state.buttonFunction = action.payload.buttonFunction || null;
    },
    hideToast: (state) => {
      state.isVisible = false;
      //   state.showToastBtn = false;
      //   state.buttonText = false;
      //   state.buttonFunction = null;
      state.message = "";
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;

export default toastSlice.reducer;
